module.exports = __webpack_public_path__ + "static/media/hbilogo-white.aa1e5ef8.png";